<template>
  <div class="sheetSetRight">
    <!-- 操作按钮 -->
    <div class="rightButtons">
      <rightOperations ref="rightOperations" :table-data="tableData" @quickAdd="quickAdd" @copyAdd="copyAdd" @queryList="queryList" @exportExcel="exportExcel">
      </rightOperations>
    </div>
    <!-- 搜索关键字 图纸表 -->
    <rightFileTable ref="rightFileTable" @sendTableData="sendTableData"></rightFileTable>
  </div>
</template>

<script>
import rightOperations from "./rightOperations/rightOperations.vue";
import rightFileTable from "./rightFileTable/rightFileTable.vue";
export default {
  components: {
    rightOperations,
    rightFileTable
  },
  data() {
    return {
      tableData: []
    };
  },
  mounted() {},
  methods: {
    quickAdd() {
      this.$refs.rightFileTable.addTable();
    },
    toSetIsMajorTwo() {
      this.$refs.rightFileTable.queryUserDict();
    },
    copyAdd() {
      this.$refs.rightFileTable.copyAddTable();
    },
    queryList() {
      this.$refs.rightFileTable.queryList();
    },
    exportExcel() {
      this.$refs.rightFileTable.exportExcel();
    },
    sendTableData(val) {
      this.tableData = val;
    }
  }
};
</script>

<style lang='scss' scoped>
.sheetSetRight {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .rightButtons {
    width: 100%;
    padding: 12px 16.5px;
    border-bottom: 1px solid #e5e8f1;
    display: flex;
  }
}
</style>

